import {
  Button,
  ButtonGroup,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { updateCategory } from '../../stores/slices/goals/goalsActions';
import AddGoal from './AddGoal';
import { MdHelpOutline, MdOpenInNew } from 'react-icons/md';
import { Prose } from '@nikolovlazar/chakra-ui-prose';
const schema = yup
  .object({
    goalCategory: yup.string().required('Category is required'),
  })
  .required();

const GoalCategory = ({ category }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenTooltip,
    onOpen: onOpenTooltip,
    onClose: onCloseTooltip,
  } = useDisclosure();
  const { userInfo } = useSelector(state => state.user);
  const dispatch = useDispatch();
  const toast = useToast();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSaveCategory = async data => {
    await dispatch(
      updateCategory({
        ...data,
        goalCategoryId: category.id,
        userId: userInfo.id,
      })
    );
    onClose();
    toast({
      description: 'Category has been updated',
      colorScheme: 'primary',
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'bottom-right',
      variant: 'primary',
    });
  };
  return (
    <React.Fragment>
      <HStack
        direction={'row'}
        justifyContent={'center'}
        alignItems={'center'}
        position="relative"
        w={'full'}
      >
        <Tooltip label="Info" aria-label="Info">
          <IconButton
            variant={'ghost'}
            size="xs"
            p={0}
            color="primary"
            icon={<MdHelpOutline size={'1.5rem'} />}
            onClick={onOpenTooltip}
          />
        </Tooltip>
        <Text
          textAlign={{ base: 'left', lg: 'center' }}
          fontWeight={'bold'}
          fontSize="xl"
          w="full"
        >
          {category.title}
        </Text>
        <ButtonGroup spacing="2" alignItems={'center'} color="primary">
          <Button
            variant={'ghost'}
            size="xs"
            fontSize={'14px'}
            onClick={onOpen}
          >
            Edit
          </Button>
          <AddGoal category={category} />
        </ButtonGroup>
      </HStack>

      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSaveCategory)}>
            <ModalHeader>Edit Category</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl id="goalCategory" isInvalid={errors.goalCategory}>
                <FormLabel>Category Name</FormLabel>
                <Input
                  defaultValue={category.title}
                  id="goalCategory"
                  {...register('goalCategory')}
                  autoFocus
                />
                <FormErrorMessage>
                  {errors.goalCategory && errors.goalCategory.message}
                </FormErrorMessage>
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Button mr={3} type="submit" isLoading={isSubmitting}>
                Save
              </Button>
              <Button
                onClick={onClose}
                variant="outline"
                disabled={isSubmitting}
              >
                Cancel
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      {isOpenTooltip && (
        <Modal isOpen={isOpenTooltip} onClose={onCloseTooltip} size={'2xl'}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{category.title}</ModalHeader>
            <HStack position={'absolute'} top={'2'} right={'3'}>
              <IconButton
                variant={'ghost'}
                size="md"
                p={0}
                color="primary"
                icon={<MdOpenInNew />}
                onClick={() => {
                  const win = window.open(
                    'about:blank',
                    null,
                    `width=500,height=400`
                  );
                  const doc = win.document;
                  doc.open('text/html');
                  doc.write(category.tool_tip);
                  doc.close();
                }}
              />
              <ModalCloseButton position={'unset'} />
            </HStack>

            <ModalBody pb={6}>
              {category.tool_tip ? (
                <Prose
                  dangerouslySetInnerHTML={{ __html: category.tool_tip }}
                />
              ) : (
                <Text>No data found.</Text>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default GoalCategory;
